export default __webpack_public_path__ + "static/media/credit_card.72b3589c.svg";